/* An imperative handle on the cart drawer, for the Add To Cart call sites.

   The drawer is rendered by a provider near the root, but the callers are the
   PDP, the shop, the homepage and the plan picker — all class components, none
   of which can use a hook. Rather than convert four containers to reach a
   context, the provider registers itself here and they call this.

   Nothing is registered until the provider mounts, and the provider only mounts
   the drawer for the unified arm, so isEnabled answering false is the normal
   state on bitsy and with the gate off. */

const DISABLED = {
  isEnabled: () => false,
  open: () => Promise.resolve(null),
  openAfterAddToCart: () => Promise.resolve(null),
  close: () => {},
};

let handle = DISABLED;

/* Pages that show the cart themselves — the checkout page has the same lines in
   its summary — need to know when the drawer changed it, or the two disagree
   until the next reload. Kept beside the handle rather than on it: a listener
   outlives any one provider mount. */
const listeners = new Set();

export const subscribeToCartChanges = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const publishCartChange = (cart) => {
  listeners.forEach((fn) => fn(cart));
};

export const registerCartDrawer = (next) => {
  handle = next || DISABLED;
  return () => {
    // Only clear if this registration is still the live one.
    if (handle === next) handle = DISABLED;
  };
};

const isEnabled = () => handle.isEnabled();
const open = (...args) => handle.open(...args);
const openAfterAddToCart = (...args) => handle.openAfterAddToCart(...args);
const close = () => handle.close();

export default { isEnabled, open, openAfterAddToCart, close };
